import { FunctionComponent } from 'react';

import BannerSection from '@/components/BannerSection';
import PostsSection from '@/components/blog/PostsSection';
import Head from 'next/head';

const Blog: FunctionComponent = () => {
  return (
    <div className="w-full bg-white overflow-hidden tracking-[normal] text-left text-[1rem] text-gray-500">
      <Head>
        <title>Blog</title>
        <meta name="description" content="Baza wiedzy firmy Binnar" />
      </Head>
      <BannerSection
        imageUrl="/blog/blog-hero.webp"
        title="Blog"
        description="To miejsce, gdzie dzielimy się wiedzą i nowinkami ze świata bezpieczeństwa drogowego. Znajdziesz tu artykuły pełne porad, analiz trendów oraz studiów przypadków, które inspirują i edukują."
      />
      <PostsSection />
    </div>
  );
};

export default Blog;
